import React from 'react';
import PropTypes from 'prop-types';
import {
  GameStatStyled,
  GameStatText,
  GameStatNumber,
} from '../../molecules/GameStats/GameStats.styled';

const TimeTaken = ({ timeTaken }) => (
  <GameStatStyled>
    <GameStatText>Taken</GameStatText>
    <GameStatNumber>
      {timeTaken}
      <small>s</small>
    </GameStatNumber>
  </GameStatStyled>
);

export default TimeTaken;

TimeTaken.propTypes = {
  timeTaken: PropTypes.number,
};

TimeTaken.defaultProps = {
  timeTaken: 0,
};



// WEBPACK FOOTER //
// ./src/components/atoms/TimeTaken/TimeTaken.js